import { Trans } from 'react-i18next'
import { useBoolean } from 'react-use'

import { VariableTextFeatureFlag } from '@makyoapp/makyo-common'
import { Column16, Image16, Text16 } from '@makyoapp/makyo-icon/icon'

import { VariableWrapper } from './VariableWrapper'

interface VariablePageContentProps {
  id?: string
  onClick: (field: VariableTextFeatureFlag) => void
}

export default function VariablePageContent({ id, onClick }: VariablePageContentProps) {
  const [show, setShow] = useBoolean(false)
  return (
    <VariableWrapper
      id={id}
      show={show}
      setShow={setShow}
      title={<Trans>Page Content</Trans>}
      icon={<Column16 width={16} height={16} />}
      defaultHeight={false}
    >
      <div className='flex flex-col'>
        {[
          { flag: VariableTextFeatureFlag.PageTitle, label: 'Name', icon: <Text16 /> },
          { flag: VariableTextFeatureFlag.PageLabel, label: 'Title', icon: <Text16 /> },
          { flag: VariableTextFeatureFlag.PageSubtitle, label: 'Sub title', icon: <Text16 /> },
          { flag: VariableTextFeatureFlag.PageDescription, label: 'Description', icon: <Text16 /> },
        ].map(({ flag, label, icon }) => (
          <button key={flag} className='gap-2 sdd-item' onClick={() => onClick(flag)}>
            {icon} {label}
          </button>
        ))}
      </div>
    </VariableWrapper>
  )
}
